import { apiClient, type ApiResponse } from '@shared/api/api-client';
import type { V2AuthContext } from '@shared/types/auth';

export const authContextApi = {
  async getCurrentContext(
    accessToken?: string,
    options?: { doctorControlRequestId?: string | null; skipDoctorControlHeader?: boolean }
  ): Promise<V2AuthContext> {
    const response = await apiClient.get<ApiResponse<V2AuthContext>>(
      '/auth/context',
      undefined,
      accessToken
        ? {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            skipAuth: true,
            skipProactiveTokenRefresh: true,
            timeout: 30000,
            timeoutProfile: 'background',
            requestLabel: 'auth-context:get-current-context',
            doctorControlRequestId: options?.doctorControlRequestId,
            skipDoctorControlHeader: options?.skipDoctorControlHeader,
          }
        : {
            timeout: 30000,
            timeoutProfile: 'background',
            requestLabel: 'auth-context:get-current-context',
            doctorControlRequestId: options?.doctorControlRequestId,
            skipDoctorControlHeader: options?.skipDoctorControlHeader,
          }
    );
    return response.data;
  },

  async switchContext(organizationId: string | null): Promise<V2AuthContext> {
    const response = await apiClient.put<ApiResponse<V2AuthContext>>('/auth/context', {
      organizationId,
    });
    return response.data;
  },
};
